import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    List,
    ListItem,
    ListItemText,
    Box,
    Divider,
    Alert
} from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon, Warning as WarningIcon } from '@mui/icons-material';

export default function GroupDetailsDialog({ group, onClose, onEdit, onDelete, isInWhitelist }) {
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const handleDelete = async () => {
        setDeleting(true);
        try {
            await onDelete(group.idProxyGroup);
            onClose();
        } catch (error) {
            console.error('Errore nell\'eliminazione:', error);
        } finally {
            setDeleting(false);
        }
    };

    if (!group) return null;

    return (
        <Dialog open={true} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle sx={{ pb: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {group.name}
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button
                            variant="outlined"
                            size="small"
                            startIcon={<EditIcon />}
                            onClick={() => onEdit && onEdit(group)}
                        >
                            Modifica
                        </Button>
                        <Button
                            variant="outlined"
                            color="error"
                            size="small"
                            startIcon={<DeleteIcon />}
                            onClick={() => setShowDeleteConfirm(true)}
                            disabled={deleting}
                        >
                            Elimina
                        </Button>
                    </Box>
                </Box>
            </DialogTitle>

            <DialogContent>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                    {group.description}
                </Typography>

                {isInWhitelist && (
                    <Alert severity="info" sx={{ mt: 1, mb: 2 }} icon={<WarningIcon />}>
                        Questo gruppo è attualmente utilizzato nella whitelist del laboratorio.
                    </Alert>
                )}

                <Divider sx={{ my: 2 }} />

                <Typography variant="h6" sx={{ mb: 1 }}>
                    URL inclusi ({group.urls?.length || 0}):
                </Typography>

                <List dense sx={{ maxHeight: 300, overflow: 'auto' }}>
                    {group.urls?.map((url, idx) => (
                        <ListItem key={idx}>
                            <ListItemText
                                primary={url}
                                primaryTypographyProps={{ fontFamily: 'monospace', fontSize: '0.9rem' }}
                            />
                        </ListItem>
                    ))}
                </List>

                {showDeleteConfirm && (
                    <Alert severity="warning" sx={{ mt: 2 }}>
                        <Typography variant="body2" gutterBottom>
                            <strong>Attenzione!</strong> Sei sicuro di voler eliminare questo gruppo?
                        </Typography>
                        {isInWhitelist && (
                            <Typography variant="body2" color="error" gutterBottom>
                                Il gruppo verrà rimosso anche dalla whitelist del laboratorio corrente.
                            </Typography>
                        )}
                        <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
                            <Button
                                variant="contained"
                                color="error"
                                size="small"
                                onClick={handleDelete}
                                disabled={deleting}
                            >
                                {deleting ? 'Eliminando...' : 'Conferma Eliminazione'}
                            </Button>
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={() => setShowDeleteConfirm(false)}
                                disabled={deleting}
                            >
                                Annulla
                            </Button>
                        </Box>
                    </Alert>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} disabled={deleting}>
                    Chiudi
                </Button>
            </DialogActions>
        </Dialog>
    );
}